<fc-header></fc-header>

<div class="min-h-[100vh] pb-16 md:pb-0">
  <router-outlet></router-outlet>
</div>
<div class="border-t-2" *ngIf="isShowFooter">
  <fc-footer></fc-footer>
</div>

<fc-mobile-navigation></fc-mobile-navigation>

<!-- whatsapp -->
<div *ngIf="chat"
  class="fixed bottom-8 right-8 z-10 hidden opacity-80 hover:opacity-100 lg:block">
  <a
    target="_blank"
    [href]="
      'https://api.whatsapp.com/send?phone=' +
      chat.whatsapp.number +
      '&text=' +
      chat.whatsapp.message
    ">
    <div
      class="z-10 rounded-full border bg-white px-6 py-2 text-lg font-medium text-emerald-600 shadow-md">
      <fa-icon [icon]="faWhatsapp"></fa-icon>
      Chat
    </div>
  </a>
</div>
